import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames, b as EGDSContextWrapper } from '../theme-provider/index-chunk.esm.js';
import { a as EGDSButton } from '../paging-button/index-chunk.esm.js';

class EGDSSecondaryButton extends React.Component {
    static displayName = 'EGDSSecondaryButton';
    render() {
        const { inverse, ...props } = this.props;
        const cssClassNames = classNames(`${EGDSButton.baseClassName}-secondary`, {
            [`${EGDSButton.baseClassName}-secondary-inverse`]: inverse,
        }, props.className);
        return (jsx(EGDSContextWrapper, { children: (context) => jsx(EGDSButton, { ...props, className: cssClassNames, "data-context": context }) }));
    }
}

export { EGDSSecondaryButton as E };
//# sourceMappingURL=index-chunk.esm.js.map
